import * as React from "react";

function Icon() {
  return (
    <svg
      style={{ flexShrink: 0 }}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 39.088 33.88"
    >
      <path
        id="megaphone"
        d="M20.333,37.776l-1.11.3a2.085,2.085,0,0,1-2.251-.821l-4.753-6.778,7.99.852,1.516,3.612A2.1,2.1,0,0,1,20.333,37.776ZM4.909,16.363l-2.58.7A3.141,3.141,0,0,0,.109,20.9L1.743,27A3.13,3.13,0,0,0,5.59,29.215l2.58-.688ZM30.618,28.646,24.294,5.04a1.046,1.046,0,0,0-1.627-.575L7.173,15.76l3.258,12.16L29.5,29.956a1.045,1.045,0,0,0,1.121-1.31ZM31.578,9.1a1.047,1.047,0,0,1-.905-1.57l1.513-2.62A1.046,1.046,0,1,1,34,5.956l-1.513,2.62A1.047,1.047,0,0,1,31.578,9.1Zm1.494,7.286a1.047,1.047,0,0,1-.27-2.058l2.922-.782a1.047,1.047,0,1,1,.542,2.022l-2.922.782A1.056,1.056,0,0,1,33.071,16.384Zm4.969,8.569a1.038,1.038,0,0,1-.522-.14L34.9,23.3a1.046,1.046,0,1,1,1.046-1.812L38.565,23a1.046,1.046,0,0,1-.524,1.953Z"
        transform="translate(0 -4.263)"
        fill="#fff"
      />
    </svg>
  );
}

export default Icon;
